import { render, staticRenderFns } from "./DealerCard.vue?vue&type=template&id=3a7179c1"
import script from "./DealerCard.vue?vue&type=script&lang=js"
export * from "./DealerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports